import {
  ADMIN_CREATE_BLOG_REQUEST,
  ADMIN_CREATE_BLOG_SUCCESS,
  ADMIN_CREATE_BLOG_FAIL,
  ADMIN_LIST_BLOG_REQUEST,
  ADMIN_LIST_BLOG_SUCCESS,
  ADMIN_LIST_BLOG_FAIL,
  ADMIN_VIEW_BLOG_REQUEST,
  ADMIN_VIEW_BLOG_SUCCESS,
  ADMIN_VIEW_BLOG_FAIL,
  ADMIN_UPDATE_BLOG_REQUEST,
  ADMIN_UPDATE_BLOG_SUCCESS,
  ADMIN_UPDATE_BLOG_FAIL,
  ADMIN_UPDATE_BLOG_PERMALINK_SUCCESS,
  ADMIN_REMOVE_BLOG_REQUEST,
  ADMIN_REMOVE_BLOG_SUCCESS,
} from "./blogTypes";

export const blogReducer = (state = { posts: [] }, action) => {
  switch (action.type) {
    // CREATE
    case ADMIN_CREATE_BLOG_REQUEST:
      return { ...state, loading: true };
    case ADMIN_CREATE_BLOG_SUCCESS:
      return { ...state, loading: false, post: action.payload, success: true };
    case ADMIN_CREATE_BLOG_FAIL:
      return { ...state, loading: false, error: action.payload };

    // LIST
    case ADMIN_LIST_BLOG_REQUEST:
      return { ...state, loading: true };
    case ADMIN_LIST_BLOG_SUCCESS:
      return {
        ...state,
        loading: false,
        // ✅ normalized data for pagination
        posts: Array.isArray(action.payload.posts)
          ? action.payload.posts
          : Array.isArray(action.payload)
          ? action.payload
          : [],
        pages: action.payload.pages || 1,
        totalCount: action.payload.totalCount || 0,
      };
    case ADMIN_LIST_BLOG_FAIL:
      return { ...state, loading: false, error: action.payload };

    // VIEW
    case ADMIN_VIEW_BLOG_REQUEST:
      return { ...state, loading: true };
    case ADMIN_VIEW_BLOG_SUCCESS:
      return { ...state, loading: false, singlePost: action.payload };
    case ADMIN_VIEW_BLOG_FAIL:
      return { ...state, loading: false, error: action.payload };

    // UPDATE
    case ADMIN_UPDATE_BLOG_REQUEST:
      return { ...state, loading: true, error: null };
    case ADMIN_UPDATE_BLOG_SUCCESS:
      return { ...state, loading: false, error: null, singlePost: action.payload };
    case ADMIN_UPDATE_BLOG_FAIL:
      return { ...state, loading: false, error: action.payload };
    case ADMIN_UPDATE_BLOG_PERMALINK_SUCCESS:
      if (state.singlePost?._id !== action.payload._id) return state;
      return {
        ...state,
        singlePost: { ...state.singlePost, ...action.payload },
      };

    // DELETE
    case ADMIN_REMOVE_BLOG_REQUEST:
      return { ...state, loading: true };
    case ADMIN_REMOVE_BLOG_SUCCESS:
      return { ...state, loading: false };

    default:
      return state;
  }
};
